module.exports = __webpack_public_path__ + "static/img/dragontiger_th.a253cc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/dragontiger_th.png
// module id = lwo7
// module chunks = 1